<ag-grid-angular
  class="ag-theme-alpine"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [ngStyle]="{ '--ag-header-background-color': headerColor }"
  (gridReady)="onGridReady($event)"
></ag-grid-angular>
